import { render } from "./modePage.vue?vue&type=template&id=345e6910"
import script from "./modePage.vue?vue&type=script&lang=js"
export * from "./modePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__